import _createForOfIteratorHelper from "/root/Etro/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import React from 'react';
import useStyles, { THUMB_SIZES } from './Thumb.styles.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

function Thumb(_ref) {
  var position = _ref.position,
      className = _ref.className,
      styles = _ref.styles,
      classNames = _ref.classNames,
      style = _ref.style,
      size = _ref.size,
      __staticSelector = _ref.__staticSelector,
      unstyled = _ref.unstyled,
      variant = _ref.variant;

  var _useStyles = useStyles(null, {
    classNames,
    styles,
    name: __staticSelector,
    unstyled,
    size,
    variant
  }),
      classes = _useStyles.classes,
      cx = _useStyles.cx;

  return /* @__PURE__ */React.createElement("div", {
    className: cx(classes.thumb, className),
    style: __spreadValues({
      left: "calc(".concat(position.x * 100, "% - ").concat(THUMB_SIZES[size], " / 2)"),
      top: "calc(".concat(position.y * 100, "% - ").concat(THUMB_SIZES[size], " / 2)")
    }, style)
  });
}

Thumb.displayName = "@mantine/core/Thumb";
export { Thumb };